<template>
  <div class="additional-services-booked">
    <content-section
      v-for="additional_service in additional_services"
      :key="additional_service.type"
      :title="
        capitalize_string(
          transcode_additional_services(additional_service.type, 99),
        )
      "
    >
      <template
        v-if="
          additional_service.type === 'CHECKED_BAGS' &&
          Object.keys(flexible_bags).length > 0
        "
      >
        <booked-bags
          :flight_offer="flight_offer"
          :flexible_bags="flexible_bags"
          :travelers="travelers"
        />
      </template>
      <template v-else-if="additional_service.type === 'SEATS'">
        <booked-seats :flight_offer="flight_offer" :travelers="travelers" />
      </template>
    </content-section>
  </div>
</template>

<script>
import {
  transcode_additional_services,
  get_paid_additional_services,
  capitalize,
} from "@liveflight/utilities";
import ContentSection from "@liveflight/components/blocks/wrappers/content-section";
import BookedSeats from "@liveflight/components/blocks/seat-map/booked-seats.vue";
import BookedBags from "@liveflight/components/blocks/additional-bags/booked-bags.vue";

export default {
  name: "additional-services-booked",
  components: {
    "booked-bags": BookedBags,
    "booked-seats": BookedSeats,
    "content-section": ContentSection,
  },
  props: {
    flight_offer: {
      type: Object,
      required: true,
    },
    travelers: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    additional_services() {
      return get_paid_additional_services(this.flight_offer);
    },
    flexible_bags() {
      try {
        return this.$store.state.liveflight.flexible_bags;
      } catch {
        return {};
      }
    },
  },
  methods: {
    capitalize_string: capitalize,
    transcode_additional_services,
  },
};
</script>
